export default __webpack_public_path__ + "static/media/logo192.50847068.png";